<template>
  <b-container fluid id="wrapper-login" class="p-0" :style="{ backgroundImage: `url(${bgImage})` }">
    <div class="sso-overlay">
      <b-container class="h-100">
        <b-row class="h-100" align-v="center" align-h="center">
          <b-col cols="12" md="10" lg="7" xl="6">
            <div class="d-flex justify-content-center mb-4">
              <router-link to="/" class="d-flex" v-bind:style="{ justifyContent: loginLogoJustifyContent }">
                <b-img :src="logoHomeImg" fluid alt="Logo" v-bind:style="{ width: loginLogoWidth }" class="logoSite" />
              </router-link>
            </div>

            <b-card class="sso-card" body-class="p-4 p-md-5" :bg-variant="cardVariant" text-variant="dark">
              <div class="d-flex align-items-start">
                <div class="sso-icon">
                  <b-icon icon="x-circle" font-scale="2" variant="danger" />
                </div>
                <div class="flex-grow-1">
                  <h3 class="mb-2">{{ title }}</h3>
                  <p class="text-muted mb-4">{{ subtitle }}</p>

                  <p class="mb-2 sso-message">{{ message }}</p>
                  <p v-if="hint" class="text-muted mb-4">{{ hint }}</p>

                  <div class="d-flex flex-wrap gap-2">
                    <router-link to="/login" class="btn btn-primary">
                      Ir al login
                    </router-link>
                  </div>

                  <div v-if="code" class="mt-4 small text-muted">
                    Código: <strong>{{ code }}</strong>
                  </div>
                </div>
              </div>
            </b-card>

            <div class="text-center mt-3 small text-muted">
              Si el problema persiste, contactá a soporte.
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('settings', ['logoHomeImg', 'bgImage', 'loginBgColor', 'loginLogoWidth', 'loginLogoJustifyContent', 'loginTextAlign']),
    code () {
      return this.$route && this.$route.query ? this.$route.query.code : null
    },
    title () {
      if (this.code === 'NO_MESA_USER') {
        return 'No es posible ingresar al sistema Mesa3'
      }
      return 'No se pudo completar el acceso'
    },
    subtitle () {
      return 'Ingreso por acceso unificado desde el sistema origen'
    },
    cardVariant () {
      return 'white'
    },
    message () {
      if (this.code === 'NO_MESA_USER') {
        return 'Tu usuario está registrado en Mesa Digital, pero todavía no tiene acceso habilitado a Mesa 3.\n\nPara poder acceder deberás ingresar con tus mismas credenciales a través del siguiente botón'
      }
      if (this.code === 'NO_PRIV') {
        return 'Tu usuario existe, pero no está habilitado para acceder a Mesa (Mesa3).'
      }
      if (this.code === 'TOKEN_EXPIRED') {
        return 'El enlace de acceso expiró.'
      }
      if (this.code === 'TOKEN_INVALID') {
        return 'El enlace de acceso no es válido.'
      }
      if (this.code === 'SSO_DISABLED') {
        return 'El acceso unificado no está habilitado en este entorno.'
      }
      return 'No se pudo completar el acceso unificado.'
    },
    hint () {
      if (this.code === 'NO_MESA_USER') {
        return null
      }
      if (this.code === 'NO_PRIV') {
        return 'Contactá al administrador para que te asigne permisos de acceso.'
      }
      if (this.code === 'TOKEN_EXPIRED' || this.code === 'TOKEN_INVALID') {
        return 'Volvé a intentarlo desde el sistema origen y generá un nuevo acceso.'
      }
      return null
    }
  }
}
</script>

<style scoped>
 #wrapper-login {
   min-height: 100vh;
   background-size: cover;
   background-position: center;
 }

 .sso-overlay {
   min-height: 100vh;
   background: rgba(255, 255, 255, 0.8);
 }

 .sso-card {
   border-radius: 12px;
   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
 }

 .sso-message {
   white-space: pre-line;
 }

 .sso-icon {
   width: 56px;
   height: 56px;
   display: flex;
   align-items: center;
   justify-content: center;
   border-radius: 14px;
   background: rgba(220, 53, 69, 0.08);
   margin-right: 16px;
 }

 .gap-2 {
   gap: 0.5rem;
 }
 </style>
